module.exports = __webpack_public_path__ + "img/car_5.4021922b.png";